/*
* PackagesService used for getting information about packages.
*/

import { Injectable } from '@angular/core';
import { Package } from '@models/package';
import { Observable, of } from 'rxjs';
import { map, publishReplay, refCount } from 'rxjs/operators';
import { BaseService } from '../base/base.service';
import { HttpService } from '../http/http.service';

@Injectable({
    providedIn: 'root'
})

export class PackagesService {

    public currentTrail: string | null;
    public packages: Package[];
    public package: Package;

    // declaration of fields
    constructor(
        public baseService: BaseService,
        public httpService: HttpService
    ) { }

    /*
    * Fetch all package from the API
    */
    public get(): Observable<Package[]> {
        if (this.currentTrail && this.packages) {
            this.currentTrail = null;
            return this.fetchPackages('/packages');
        } else {
            return (!this.packages) ? this.fetchPackages('/packages') : of(this.packages);
        }
    }

    /*
    * Fetch packages of a specific trail from the API
    */
    public getByTrail(trailId: string): Observable<Package[]> {
        if (trailId === this.currentTrail) {
            return of(this.packages);
        } else {
            this.currentTrail = trailId;
            return this.fetchPackages(`/trail/${trailId}/packages`);
        }
    }

    /*
    * Wrapper function to fetch packages from the API
    */
    private fetchPackages(url: string): Observable<Package[]> {
        return this.httpService.get(url).pipe(
            map((response: any) => {
                this.packages = response.data.sort((a: Package, b: Package) => (a.order != null ? a.order : Infinity) - (b.order != null ? b.order : Infinity));
                return this.packages;
            }),
            publishReplay(1),
            refCount());
    }

    /*
    * Get package by id from the API
    */
    public getById(id: string): Observable<Package> {
        if (this.package && (this.package._id === id || this.package.slug === id)) {
            return of(this.package);
        } else {
            return this.httpService.get(`/packages/${id}`).pipe(
                map((response: any) => {
                    this.package = response.data;
                    return response.data
                }));
        }
    }
}